import React, { Component } from 'react'
import { connect } from 'react-redux'
import { get } from 'lodash'
import PropTypes from 'prop-types'
import Slider from 'rc-slider'
import AvatarEditor from 'react-avatar-editor'
import { injectIntl } from 'react-intl'
import { Image } from 'containers/misc'
import { Modal } from 'components/layout'
import { CircleLoader } from 'components/loaders'
import { modal } from 'helpers/decorators'
import { SUPPORTED_IMG_TYPES } from 'constants/enums'
import styles from './image-cropper.styl'

@connect(({ auth }) => ({
  user: auth.user
}))
@modal.trigger()
@injectIntl
class ImageCropper extends Component {
  static propTypes = {
    loading: PropTypes.bool,
    onCloseNested: PropTypes.func.isRequired,
    nestedModal: PropTypes.func.isRequired,
    change: PropTypes.func.isRequired,
    formPrefix: PropTypes.string,
    photoUrl: PropTypes.string,
    disabled: PropTypes.bool,
    intl: PropTypes.object
  }

  state = {
    image: null,
    isLoading: false,
    isRemoving: false,
    mouseOver: false,
    scale: 1.2
  }

  componentDidMount() {
    if (__CLIENT__) {
      require('blueimp-canvas-to-blob')
    }
  }

  handleImageSelection = e => {
    const file = e.target.files[0]
    const reader = new FileReader()

    if (!SUPPORTED_IMG_TYPES.includes(file.type)) {
      return this.setState({ unsupportedFile: true })
    }

    this.state.unsupportedFile && this.setState({ unsupportedFile: false })

    reader.onload = base64file => {
      this.setState(
        {
          image: base64file.target.result,
          imageType: file.type,
          fileName: file.name,
          isRemoving: false
        },
        () => {
          this.props.nestedModal('personal-image-crop')
        }
      )
    }
    reader.readAsDataURL(file)
  }

  handleImageCropping = () => {
    const canvas = this.refs.editor.getImage()

    if (canvas.toBlob) {
      this.setState({ isLoading: true }, () =>
        canvas.toBlob(blob => {
          this.setState({ imageToDisplay: canvas.toDataURL() }, () => {
            this.setState({ isLoading: false }, () => {
              this.props.change('file', {
                blob,
                fileName: this.state.fileName
              })
              this.props.onCloseNested()
            })
          })
        }, this.state.imageType)
      )
    } else {
      console.log('Browser doesnt support toBlob func')
    }
  }

  handleImageRemove = () => {
    this.setState({
      image: null,
      imageToDisplay: null,
      isRemoving: true
    })
    this.props.photoUrl && this.props.change('helpers.deletedFile', true)
    this.props.change('file', null)
    this.props.change(`${this.props.formPrefix}photoUrl`, null)
  }

  handleMouseEnter = () => this.setState({ mouseOver: true })

  handleMouseLeave = () => this.setState({ mouseOver: false })

  handleChangeScale = scale => this.setState({ scale })

  render() {
    const { disabled, loading, intl, photoUrl } = this.props
    const {
      image,
      imageToDisplay,
      mouseOver,
      isLoading,
      scale,
      unsupportedFile,
      isRemoving,
      user
    } = this.state
    const hoverClass = mouseOver ? styles.hover : ''

    return (
      <div
        className={`${styles.photo} ${hoverClass}`}
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
      >
        {loading &&
          <div className={styles.loader}>
            <CircleLoader extendClass={styles.spinner} dark size={26} />
          </div>}

        {!imageToDisplay &&
          !photoUrl &&
          <div className={styles.icoWrap}>
            <span className={`ico ico--user ${styles.ico}`} />
          </div>}

        {!imageToDisplay &&
          photoUrl &&
          isRemoving &&
          <div className={styles.icoWrap}>
            <span className={`ico ico--user ${styles.ico}`} />
          </div>}

        {!imageToDisplay &&
          photoUrl &&
          !isRemoving &&
          <div className={styles.icoWrap}>
            <Image
              src={photoUrl}
              className={styles.img}
              ref="image"
              width="100px"
              height="100px"
              authCode={get(user, 'blobAccessAuthorizationCode')}
            />
          </div>}
        {imageToDisplay &&
          <img
            className={styles.img}
            src={imageToDisplay}
            ref="image"
            width="100px"
            height="100px"
          />}
        {(imageToDisplay || photoUrl) &&
          !disabled &&
          !isRemoving &&
          <div className={styles.imgWrap}>
            <button
              type="button"
              className={styles.btnRemove}
              onClick={this.handleImageRemove}
            >
              <i className="ico ico--delete" />
            </button>
          </div>}

        {!disabled &&
          <input
            type="file"
            className={styles.fileInput}
            onChange={this.handleImageSelection}
            value=""
          />}

        <Modal
          id="personal-image-crop"
          action="Crop"
          onSubmit={this.handleImageCropping}
          isLoading={isLoading}
          dontCloseAfterSubmit
          className={styles.modal}
        >
          <div style={{ textAlign: 'center' }}>
            <AvatarEditor
              ref="editor"
              image={image}
              width={235}
              height={235}
              border={30}
              color={[255, 255, 255, 0.6]}
              scale={scale}
            />
            <Slider
              className={styles.slider}
              min={1}
              max={10}
              step={1}
              onChange={this.handleChangeScale}
              value={scale}
            />
          </div>
        </Modal>

        {imageToDisplay &&
          !disabled &&
          unsupportedFile &&
          <p className={styles.error}>
            {intl.formatMessage({
              id: 'notifications.file_type_is_not_supported',
              defaultMessage: 'File type is not supported'
            })}
          </p>}
      </div>
    )
  }
}

export default ImageCropper
